import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const getAllsupportEmails = createAsyncThunk(
  "supportEmail/getAll",
  async () => {
    const response = await api.get(`/support-email-config`);
    return response.data;
  }
);

export const updateSupportEmails = createAsyncThunk(
  "supportEmail/update",
  async (data) => {
    const response = await api.put(`/support-email-config`, data);
    return response.data;
  }
);

